import type { EditableRegion, MosaicRegion, RegionEffect } from "./types";

export function editableRegions(regions: MosaicRegion[]): EditableRegion[] {
  return regions.filter((region): region is EditableRegion => region.kind !== "erase");
}

/** A fresh copy with a new id, nudged so it does not hide the original. */
export function copyRegion(region: EditableRegion, offset: number): EditableRegion {
  return {
    ...region,
    id: crypto.randomUUID(),
    x: region.x + offset,
    y: region.y + offset,
    effect: { ...region.effect },
    ...("points" in region
      ? { points: region.points.map((point) => ({ ...point })) }
      : {}),
  };
}

export function mapRegions(
  regions: MosaicRegion[],
  ids: ReadonlySet<string>,
  update: (region: EditableRegion) => EditableRegion,
): MosaicRegion[] {
  return regions.map((region) =>
    region.kind !== "erase" && ids.has(region.id) ? update(region) : region,
  );
}

/** Keys whose values differ between the selected ranges. */
export function mixedEffectKeys(regions: EditableRegion[]): Array<keyof RegionEffect> {
  if (regions.length < 2) return [];
  const [first, ...rest] = regions;
  return (Object.keys(first.effect) as Array<keyof RegionEffect>).filter((key) =>
    rest.some((region) => region.effect[key] !== first.effect[key]),
  );
}
